import { Sort } from '@empathy/search-types';
import { SearchState } from '../../../models';
import { SEARCH_MUTATIONS_KEYS } from '../search.const';
import { SearchMutation } from '../search.interfaces';

export class SetSortMutation implements SearchMutation {
  mutations = {
    [SEARCH_MUTATIONS_KEYS.setSort]: (searchState: SearchState, sort: Sort) => {
      searchState.sort = sort;
    }
  };
}
